import type { DeliverableStatus } from '@k2/domain/deliverable-status'

export type BadgeTone = 'neutral' | 'outline' | 'accent' | 'success' | 'warning' | 'danger' | 'solid'

const TONES: Record<DeliverableStatus, BadgeTone> = {
  draft: 'neutral',
  in_progress: 'accent',
  ready: 'success',
  published: 'solid'
}

export const statusTone = (status: DeliverableStatus): BadgeTone => TONES[status]

const DOTS: Record<DeliverableStatus, string> = {
  draft: 'bg-subtle',
  in_progress: 'bg-accent',
  ready: 'bg-success',
  published: 'bg-primary'
}

export const statusDot = (status: DeliverableStatus) => DOTS[status]
